<template>
  <div>
    <div
      class="grid justify-items-center gap-2"
      :class="gridClass"
    >
      <div
        v-for="(item, itemIdx) in stats"
        :key="itemIdx"
        class="w-full flex-1 flex"
      >
        <ProgramKeyIndicator :item="item" :index="itemIdx" :support-program-id="supportProgramId" />
      </div>
    </div>
    <div class="pt-4">
      <div
        v-for="(source, index) in statsSources"
        :key="index"
        class="flex flex-col p-2"
      >
        <p>{{ source }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
    SupportProgramMarketStatistic
} from "@/program/interfaces/Program";
import {computed} from "vue";
import ProgramKeyIndicator from "@/program/components/program-statistics/ProgramKeyIndicator.vue";

const {stats, gridClass = "md:grid-cols-2 xl:grid-cols-4"} = defineProps<{
    stats: SupportProgramMarketStatistic[]
    supportProgramId: number;
    gridClass?: string
}>();

const statsSources = computed(() => {
    return stats.filter(stat => {
        return 'source' in stat;
    }).map(stat => stat.source);
});
</script>
